import { MODAL_STATE_LOCAL_STORAGE_KEY, MODAL_REDUCER_NAME, MODAL_INITIAL_STATE } from './Constants';

import { useModal } from './Selector';
import modalReducer, { showModal, hideModal } from './Reducer';
// import { saveUserInLocalStorage } from './Middleware';
// import { removeUserInLocalStorage } from './UserController';

export {
  MODAL_STATE_LOCAL_STORAGE_KEY,
  MODAL_REDUCER_NAME,
  MODAL_INITIAL_STATE,
  showModal,
  hideModal,
  useModal,

  //   useIsLoggedIn,
  //   useSub,
  //   useUser,
  //   setLoggedIn,
  //   setUserInfo,
  //   removeAllUserState,
  //   saveUserInLocalStorage,
  //   removeUserInLocalStorage,
};

export default modalReducer;
